export default function directive() {
  return {
    link: function(scope, el, attrs) {
      el.bind('error', function() {
        if(attrs.src != attrs.defaultSponsorLogo) {
          attrs.$set('src', attrs.defaultSponsorLogo);
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./js/containers/causePortal/directives/defaultSponsorLogo.js